import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BackToDashboardModal from './BackToDashboardModal';
import { goTo } from '../../stateManagement/engine/actions/HistoryActions';
import { clearCustomerSession } from '../../stateManagement/engine/actions/SessionActions';

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    ...bindActionCreators({ goTo, clearCustomerSession }, dispatch),
    ...ownProps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BackToDashboardModal);
